import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonBase, Stack, Typography } from '@mui/material';

import { ZoneCodeBadge } from '@mopla/ui';

interface IZoneTileProps {
	code: string;
	name: string;
	isSelected: boolean;
	isIncluded: boolean;
	onClick: () => void;
}

export const ZoneTile: FC<IZoneTileProps> = ({
	code,
	name,
	isSelected,
	isIncluded,
	onClick,
}) => {
	const { t } = useTranslation('ticketshop');

	return (
		<ButtonBase
			onClick={onClick}
			disableRipple
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-start',
				gap: 1,
				p: 1.5,
				borderRadius: '8px',
				width: '100%',
				height: 70,
				textAlign: 'left',
				border: '2px solid transparent',
				boxSizing: 'border-box',
				...(isSelected
					? {
							background:
								'linear-gradient(#fff, #fff) padding-box, linear-gradient(to top right, #0E1C5B 0%, #608DF0 100%) border-box',
							boxShadow: '0px 4px 3px rgba(24, 39, 75, 0.12)',
					  }
					: {
							bgcolor: 'common.white',
							boxShadow: (theme) =>
								`inset 0 0 0 0.5px ${
									theme.palette.solutions?.[600] ?? '#66758f'
								}`,
					  }),
			}}
		>
			<ZoneCodeBadge code={code} />
			<Stack
				gap={0.5}
				sx={{ flex: 1, minWidth: 0, height: 46, justifyContent: 'center' }}
			>
				<Typography
					variant="b1-sb"
					color="primary.main"
					sx={{
						wordBreak: 'break-word',
						textAlign: 'left',
						lineHeight: 1.5,
					}}
				>
					{name}
				</Typography>
				{isIncluded && (
					<Typography variant="l1" color="solutions.600">
						{t('ticket_detail.zones_included')}
					</Typography>
				)}
			</Stack>
		</ButtonBase>
	);
};
